export const standardSliderSx = {
  width: "100%",
  minWidth: 0,
  color: "#1976d2",
  px: 0.5,
  "& .MuiSlider-thumb": {
    width: 16,
    height: 16,
  },
  "& .MuiSlider-track": {
    height: 4,
  },
  "& .MuiSlider-rail": {
    height: 4,
    opacity: 0.35,
  },
  "& .MuiSlider-mark": {
    width: 3,
    height: 3,
    backgroundColor: "#9fb7cf",
  },
  "& .MuiSlider-markLabel": {
    fontSize: "9px",
    lineHeight: "12px",
    whiteSpace: "nowrap",
    color: "#52637a",
  },
  "& .MuiSlider-markActive": {
    backgroundColor: "#9fb7cf",
  },
  "& .MuiSlider-valueLabel": {
    fontSize: "10px",
    fontWeight: 600,
  },
};

export const selectedSliderMarkSx = (selectedMarkIndices: number | number[] = []) => {
  const indices = Array.isArray(selectedMarkIndices) ? selectedMarkIndices : [selectedMarkIndices];

  return indices.reduce<Record<string, Record<string, string | number>>>((styles, index) => {
    if (index < 0) return styles;

    styles[`& .MuiSlider-mark[data-index="${index}"]`] = {
      width: 4,
      height: 4,
      backgroundColor: "#1976d2",
    };
    styles[`& .MuiSlider-markLabel[data-index="${index}"]`] = {
      fontSize: "10px",
      fontWeight: 700,
      color: "#1976d2",
    };
    return styles;
  }, {});
};

export const getSliderMarkIndices = (
  marks: ReadonlyArray<{ value: number }>,
  values: number | number[]
) => {
  const selectedValues = Array.isArray(values) ? values : [values];
  return selectedValues
    .map((value) => marks.findIndex((mark) => mark.value === value))
    .filter((index) => index >= 0);
};
